/* tslint:disable:typedef-whitespace */
/*
tslint:disable:import-spacing no-inferrable-types
variable-name align no-trailing-whitespace component-class-suffix
no-string-literal component-selector
*/

import {ICommand}                from '@/util/i.command';
import {
  WorkBlock
}                                from '@/models/scenario/work.block';
import {WorkBlockChange}         from '@/screens/ide/workblox/work.block.change';
import {WorkBloxEditorComponent} from '@/components/work.blox.editor.component';
import {Logger}                  from '@/util/logger';

/**
 *
 * @class DeleteWorkBlockCommand
 *
 * @brief reversible deletion of a work block
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      June 2020
 *
 */
export class DeleteWorkBlockCommand implements ICommand {

  private oldValue: WorkBlockChange         = null;
  private   editor: WorkBloxEditorComponent = null;
  private oldBlock: WorkBlock               = null;

    constructor(oldValue: WorkBlockChange, editor: WorkBloxEditorComponent) {

    this.oldValue = oldValue;
    this.editor   = editor;
  }

  /** effect the command */
  execute() {

    /* find the block of the current selection */

    const    input: WorkBlockChange = this.oldValue.snapshot;

    this.oldBlock = Array.from(this.editor.scenario.workBlocks().values()).
      find(x => x._id === this.oldValue.id);

    Logger.debug('[workblox/table:del] deleting ', this.oldBlock);

    /* remove it from the scenario */

    this.editor.scenario.workBlocks().delete(this.oldBlock._id);

    /* refresh the views */

    this.editor.table.refreshTable();
    this.editor.graph.refreshGraph();

    Logger.debug('[workblox/table:del] refreshed.');

    /* clear the view selections */

    this.editor.table.doSelection(null);
    this.editor.graph.doSelection(null);
    this.editor.editor.clear();

    Logger.debug('[workblox/table:del] selection cleared.');
  }

  /** reverse the command's effects */
  unExecute() {

    /*
     * add the block back to the scenario, we can just re-insert, because scenario doesn't
     *  ever reuse workblock IDs
     *
     */

    Logger.debug('[workblox/table:del] adding back ', this.oldBlock);

    this.editor.scenario.workBlocks().set(this.oldBlock._id, this.oldBlock);

    /* refresh the views (so the block disappears) */

    this.editor.table.refreshTable();
    this.editor.graph.refreshGraph();

    Logger.debug('[workblox/table:del] refreshed.');

    /*
     * (re)select what was selected when we deleted, this brings back the
     * selection, and the the edit inputs as they were just before the
     * deletion.
     *
     */

    this.editor.table.doSelection(this.oldValue);

  }

  /** return a string summary of this command */
  asString(): string {

    const b = (this.oldValue instanceof WorkBlockChange) ? this.oldValue.id : '';

    return '[workblox/table:del] ' + b;
  }

}
